import { render, staticRenderFns } from "./OrderDeliveryTile.vue?vue&type=template&id=6827e41b&scoped=true"
import script from "./OrderDeliveryTile.vue?vue&type=script&lang=js"
export * from "./OrderDeliveryTile.vue?vue&type=script&lang=js"
import style0 from "./OrderDeliveryTile.vue?vue&type=style&index=0&id=6827e41b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6827e41b",
  null
  
)

export default component.exports